define([
	"dojo/_base/declare",
	"csi/heading/String",
	"csi/locale"
], function(declare,StringRen,locale) {

	return declare(StringRen, {
		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: return localized attribute type
			return locale.getAttributeType(value);
		}
	});
});